"use client";
import * as React from "react";
import  {Navigation}  from "./Navigation";
import { HeroSection } from "./HeroSection";
import { MissionSection } from "./MissionSection";
import { FeatureSlider } from "./FeatureSlider";
import AIFriendSection from "./AIFriendSection";
import { Link } from "react-router-dom";
import { GamesSection } from "./GamesSection";
import { TokenHighlights } from "./TokenHighlights";
import  {TokenomicsSection}  from "./TokenomicsSection";
import { StakingSection } from "./StakingSection";
import { FAQSection } from "./FAQSection";
import { RoadmapSection } from "./RoadmapSection";
import { Box5 } from "./Box5";
import  Footer  from "./Footer";
import { BackgroundElements } from "./BackgroundElements";
function UpdateIntroductionPageV4() {
  return (
<div className="relative w-full min-h-screen overflow-hidden bg-transparent">
      {/* 🔆 LEFT GLOW */}
      <div className="pointer-events-none absolute top-[25%] left-[-200px] w-[500px] h-[500px] bg-[#FF82BD] opacity-40 rounded-full blur-[240px] z-0" />

      {/* 🔆 RIGHT GLOW */}
      <div className="pointer-events-none absolute top-[40%] right-[-200px] w-[500px] h-[500px] bg-[#FF82BD] opacity-40 rounded-full blur-[240px] z-0" />

      {/* 🔵 CENTER DARK GLOW */}
      <div className="pointer-events-none absolute top-[50%] left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-[#1E1A2E] opacity-80 rounded-full blur-[280px] z-0" />

      {/* ✅ Main App Content */}
      <div className="relative z-10 flex flex-col items-center w-full">
        <div className="min-h-screen w-full">
          <div className="relative w-full max-w-[1250px] mx-auto px-4 sm:px-8">
            <BackgroundElements />
            <Navigation />
            <HeroSection />
            <MissionSection />
          </div>
        </div>

        <FeatureSlider />
        <AIFriendSection />
        <GamesSection />
        <TokenHighlights />
        <TokenomicsSection />
        <Box5/>
        <StakingSection />
        <FAQSection />
        <RoadmapSection />
        <Footer />
      </div>
    </div>


  );
}

export default UpdateIntroductionPageV4;
